import React, { useEffect } from "react";
import { useLocation } from 'react-router-dom';
import OrganizationServices from "services/OrganizationServices";
import { MainCard, Progress } from 'components';
import CustomTabs from "./OrgComponets/Tab";
import OrganizationTab from './OrganizationsTabs/OrganizationTab';
import BranchesTab from './OrganizationsTabs/BranchesTab';
import DepartmentsTab from './OrganizationsTabs/DepartmentsTab';
import OfficersTab from './OrganizationsTabs/OfficersTab';
import EmployeesServices from "services/EmployeesServices";

const OrganizationDetailsPage = () => {
  const refreshOrgData = async () => {
    if (!orgId) return;
    setLoading(true);
    try {
      const response = await OrganizationServices.getById(orgId);
      let orgData = null;
      if (response?.data?.organization) {
        orgData = response.data.organization;
      } else if (response?.data) {
        orgData = response.data;
      } else {
        orgData = response;
      }
      setOrg(orgData);
    } finally {
      setLoading(false);
    }
  };
  const updateOrgStatus = async (newStatus) => {
    if (!org?.id) return;
    setLoading(true);
    try {
      await OrganizationServices.update(org.id, { status: newStatus ? 'Active' : 'Inactive' });
      const response = await OrganizationServices.getById(org.id);
      let orgData = null;
      if (response?.data?.organization) {
        orgData = response.data.organization;
      } else if (response?.data) {
        orgData = response.data;
      } else {
        orgData = response;
      }
      setOrg(orgData);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };
  const location = useLocation();
  const orgId = location.state?.org?.id || location.state?.id;
  const [org, setOrg] = React.useState(null);
  const [tabValue, setTabValue] = React.useState('organization');
  const [loading, setLoading] = React.useState(false);
  

  const [contactInfo, setContactInfo] = React.useState({
    name: '',
    email: '',
    phone: '',
    address: ''
  });

  const tabs = [
    { label: 'Organization', value: 'organization' },
    { label: 'Branches', value: 'branches' },
    { label: 'Departments', value: 'departments' },
    { label: 'Officers', value: 'officers' },
  ];
  useEffect(() => {
    if (!orgId) return;
    setLoading(true);
    OrganizationServices.getById(orgId)
      .then(response => {
        let orgData = null;
        if (response?.data?.organization) {
          orgData = response.data.organization;
        } else if (response?.data) {
          orgData = response.data;
        } else {
          orgData = response;
        }
        setOrg(orgData);
      })
      .finally(() => setLoading(false));
  }, [orgId]);

  useEffect(() => {
    async function fetchData() {
      if (!org?.id) return;
      try {
        const response = await EmployeesServices.get({
          organization_id: org.id,
          type: 'Organization Admin',
          status: 'Active'
        });
        const admins = response?.data?.view?.data || response;
        if (admins && admins.length > 0) {
          const adminData = admins[0];
          setContactInfo({
            name: adminData.name || '',
            email: adminData.email || '',
            phone: adminData.contact_no || '',
            address: adminData.address || ''
          });
        } else {
          setContactInfo({ name: '', email: '', phone: '', address: '' });
        }
      } catch (error) {
        setContactInfo({ name: '', email: '', phone: '', address: '' });
      }
    }
    fetchData();
  }, [org]);

  return (
    <MainCard>
      <CustomTabs
        tabs={tabs}
        value={tabValue}
        onChange={(e, v) => setTabValue(v)}
        sx={{ mt: 2, mb: 2 }}
      />
      {loading ? (
          <Progress />  
      ) : (
        <>
          {tabValue === 'organization' && (
            <OrganizationTab
              org={{
                ...org,
                isActive: org?.status === 'Active', 
                logo: org?.logo || undefined
              }}
              contactInfo={contactInfo}
              onStatusChange={updateOrgStatus}
              onEditLoading={setLoading}
              onEditRefresh={refreshOrgData}
            />
          )}
          {tabValue === 'branches' && (
            <BranchesTab org={org} />
          )}
          {tabValue === 'departments' && (
            <DepartmentsTab org={org} />
          )}
          {tabValue === 'officers' && (
            <OfficersTab org={org} />
          )}
        </>
      )}
    </MainCard>
  );
};

export default OrganizationDetailsPage;